import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "../../../styles";
import { teamColors } from "../../../styles/colors";

const base = style({
  display: "flex",
  flexShrink: 0,
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
});

const defaultAvatarStyles = style([
  base,
  { backgroundColor: vars.colors.surfaceVariant },
]);

export const teamAvatarStyles = styleVariants(teamColors, (teamColorData) => [
  base,
  {
    backgroundColor: teamColorData.backgroundColor,
    color: teamColorData.color,
  },
]);

export const avatarSizeVariants = styleVariants({
  small: { borderRadius: vars.radii.s, width: "2.4rem", height: "2.4rem" },
  medium: { borderRadius: vars.radii.m, width: "4.8rem", height: "4.8rem" },
  large: { borderRadius: vars.radii.m, width: "8rem", height: "8rem" },
});

export { defaultAvatarStyles };
